export default __webpack_public_path__ + "static/media/search_icon.d31628c8.svg";